import {UserDB} from '@/services/db'
import bookSync from '@/services/booksync'

const db = new UserDB()

const fetchBookmarks = async ({ commit, rootState }) => {
  try {
    const bookmarksRemote = await bookSync.getUserBookmarks(rootState.user.accessToken, rootState.book.book._id)

    if (bookmarksRemote.objects) {
      commit('SET_BOOKMARKS', bookmarksRemote.objects)
    }

    return bookmarksRemote
  } catch {
    const bookmarksLocal = await db.bookmarks.where('book').equals(rootState.book.book._id).toArray()

    commit('SET_BOOKMARKS', bookmarksLocal)

    return bookmarksLocal
  }
}


const fetchAndSaveBookmarks = async ({ commit, rootState }) => {
  try {
    const bookmarksRemote = await bookSync.getUserBookmarks(rootState.user.accessToken, rootState.book.book._id)

    if (bookmarksRemote.objects) {
      bookmarksRemote.objects.forEach(bookmark => {
        db.bookmarks.put(bookmark)
      })
      commit('SET_BOOKMARKS', bookmarksRemote.objects)
    }

    return bookmarksRemote
  } catch {
    const bookmarksLocal = await db.bookmarks.where('book').equals(rootState.book.book._id).toArray()

    commit('SET_BOOKMARKS', bookmarksLocal)

    return bookmarksLocal
  }
}

const addUserBookmark = ({ rootState }, pageNumber) => {
  const bookmark = {page: pageNumber, book: rootState.book.book._id, id: pageNumber + rootState.book.book._id}
  db.bookmarks.put(bookmark)
  // Push to server (make sure there is backgrounSync in SW)
  return bookSync.addUserBookmark(rootState.user.accessToken, bookmark)
}

const deleteUserBookmark = async ({ rootState }, bookmarkId) => {
  db.bookmarks.where('id').equals(bookmarkId).delete()
  // Push to server (make sure there is backgrounSync in SW)
  return bookSync.deleteUserBookmark(rootState.user.accessToken, bookmarkId)
}

export default {
  fetchBookmarks,
  fetchAndSaveBookmarks,
  addUserBookmark,
  deleteUserBookmark
}
